import { useCallback } from 'react';
import { useMutation } from '@tanstack/react-query';
import useErrorMessage from '@app/hooks/useErrorMessage';
import { POST_PORTFOLIO_ITEM } from '../../mutations';

const usePostPortfolioItem = ({ success, error }) => {
  const { mutate, isLoading } = useMutation(POST_PORTFOLIO_ITEM, {
    onSuccess: (data) => success(data),
  });

  const getErrorMessage = useErrorMessage();

  const postPortfolioItem = useCallback(
    async (data, action) => {
      try {
        await mutate({ action, data });
      } catch (err) {
        error(getErrorMessage(err));
      }
    },
    [error, mutate, getErrorMessage],
  );

  return {
    postPortfolioItem,
    isLoading,
  };
};

export default usePostPortfolioItem;
